module.exports = __webpack_public_path__ + "img/full_right_angle_corner_line.88f53cab.svg";